const PentagonLegend = ({ plots, rollingAverage, legendRef }) => (
  <div
    className="duval-legend"
    ref={legendRef}
  >
    {plots &&
      plots.map((plot, idx) => (
        <div
          key={idx}
          className="duval-legend-item"
        >
          <svg
            width="10"
            height="10"
            style={{ marginRight: '0.5rem' }}
          >
            <rect
              width="10"
              height="10"
              fill={plot.color}
            />
          </svg>
          {plot.label}
        </div>
      ))}
    {rollingAverage?.show &&
      plots?.map((plot, idx) => (
        <div
          key={idx}
          className="duval-legend-item"
        >
          <svg
            width="10"
            height="10"
            style={{ marginRight: '0.5rem' }}
          >
            <rect
              width="10"
              height="10"
              fill={plot.rollingAverageColor}
            />
          </svg>
          {plot.label} rolling average {`(${rollingAverage.decay})`}
        </div>
      ))}
  </div>
);

export default PentagonLegend;
